module.exports={turnstile_modal:{message:"Güvenlik ayrıntıları doğrulanıyor"}};